export default __webpack_public_path__ + "static/media/seo-call.dea8d85c.wav";